// Older Creator initializers saved this exact empty menu without a Blockly ID.
// Repair only that default, on the candidate being saved. Customized source still
// goes through normal ID validation. Deriving the ID from the record makes replay stable.
module.exports = function ensureDefaultProfileMenuId(record) {
    const roots = record.blockly?.blocks?.blocks;
    if (record._id && roots?.length === 1 && roots[0].type === 'menu_Menu' && Object.keys(roots[0]).length === 1) {
        roots[0].id = `profile-menu-${record._id}`;
    }
};
